
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  skipLLM: true,
  maxTocLevel: 4,
  description: "Instantly add customer bank accounts to Finix to accept and send payments with tokenized payment information. It's fast, frictionless, and secure."
};
export const partnerProps = {
  partner: 'Finix',
  clientLibrary: 'finix',
  subtitle: metadata.description,
  registrationUrl: 'https://finix.payments-dashboard.com/signup/?utm_campaign=Plaid_Partner_Program&utm_source=Plaid&utm_medium=Website&utm_content=Plaid_Docs',
  apiUrl: 'https://finix.com/docs/guides/payments/online-payments/getting-started/adding-bank-accounts-with-plaid/?utm_campaign=Plaid_Partner_Program&utm_source=Plaid&utm_medium=Website&utm_content=Plaid_Docs',
  isPaymentProcessor: true
};

const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p>{`Finix and Plaid have partnered to bring Finix's customers a fast, frictionless, and secure solution to adding bank accounts to Finix's platform for payments. The partnership makes it simple and secure to use bank accounts for Finix's suite of payments solutions, including ACH Direct Debits and bank payouts. Some highlights of the joint solution include:`}</p>
    <ul>
      <li parentName="ul">{`Instant bank account existence and ownership validation, which makes it fast and secure to board customers onto Finix's platform`}</li>
      <li parentName="ul">{`An excellent user experience, with customers able to connect their bank accounts to Finix with Plaid Link`}</li>
      <li parentName="ul">{`Optionality, with API and low-code / embedded versions of the Plaid Link experience available to Finix customers`}</li>
    </ul>
    <p>{`Finix customers can choose to embed Plaid Link into their own front-end experiences to connect their users' bank accounts, or use Finix's low-code / no-code onboarding forms that come with Plaid Link embedded. Both options deliver a smooth, secure experience for Finix customers. Both options let Finix customers use Plaid-connected bank accounts for Finix's suite of payments solutions.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.FinixInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
